import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, rdata) {
  let has_admin = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location.permissions.has_admin',
  })

  let user_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'user.id',
  })

  let board_created_user_id = useDataValue({
    viewPath: props.viewPath,
    context: 'board',
    path: 'created_by',
  })

  // if it's 'my' board I can also see the needs admin flagged tabs
  if (user_id === board_created_user_id) {
    has_admin = true
  }

  return useMemo(
    () =>
      rdata
        .filter(tab => (tab.needs_admin ? has_admin : true))
        .map(({ needs_admin, ...tab }) => tab),
    [rdata, has_admin]
  )
}
